import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { RESOURCES } from '@crewmeister/shared';
import { UI_STATE_KEY_USER_APP_IN_TERMINAL_MODE } from '../action-creators/ui-actions';
import * as selectors from '../selectors';
import { collections } from '../utils';

import { loadCurrentAuthentication } from '../action-creators/authentication-actions';
import { api, apiV3, history, reduxStore } from '../lib';
import { POST_PROCESS_FUNCTION_NAME } from '../types';

import AppSwitcher from './app-switcher';

const { composeReverse } = collections;
const { selectAuthentication, selectCurrentAuthenticationLoading, selectPermissions, selectCrews } = selectors;

const nonce = new URLSearchParams(window.location.search).get('nonce');

if (nonce) {
  Promise.resolve()
    .then(() => {
      api.tokenStore.removeToken('user');
      api.tokenStore.removeToken('crew');
    })
    .then(() => apiV3.getService(RESOURCES.AUTHENTICATION_USER, POST_PROCESS_FUNCTION_NAME.SET_USER_TOKEN))
    .then((service) => service.createOne({ nonce }))
    // Creates a V2 session token so V2 endpoints accept this session after V3 nonce exchange.
    .then(({ token }) => api.createUserAuthentication({ v3Token: token }))
    .then(() => {
      const params = new URLSearchParams(window.location.search);
      params.delete('nonce');
      history.replace({ search: params.toString() });
    })
    .then(() => reduxStore.dispatch(loadCurrentAuthentication.unmemoized({ api })));
} else {
  reduxStore.dispatch(loadCurrentAuthentication.unmemoized({ api }));
}

global.api = api;

const mapStateToProps = (state, props) => ({
  userAppInTerminalMode: state.ui.ui[UI_STATE_KEY_USER_APP_IN_TERMINAL_MODE],
  crews: selectCrews(state),
  authentication: selectAuthentication(state, props),
  permissions: selectPermissions(state),
  isLoading: selectCurrentAuthenticationLoading(state, props),
  hasCompletedInitialLoad: state.authentication.hasCompletedInitialLoad,
});

const AppSwitcherContainer = composeReverse(withRouter, connect(mapStateToProps))(AppSwitcher);

export default AppSwitcherContainer;
